import { useState, useEffect } from 'react';

export const useMediaQuery = (maxWidth) => {
  const [matches, setMatches] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.innerWidth <= maxWidth;
    }
    return false;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const mediaQuery = window.matchMedia(`(max-width: ${maxWidth}px)`);

    const handleChange = (e) => {
      setMatches(e.matches);
    };

    setMatches(mediaQuery.matches);
    mediaQuery.addEventListener('change', handleChange);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, [maxWidth]);

  return matches;
};